import { FC } from 'react';

import s from './IntegrationsTab.module.scss';

export const LINKS = {
  telegram_notify:
    'https://support.smartshell.gg/hc/ru/articles/11020163408653-%D0%9E%D1%82%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B0-%D1%83%D0%B2%D0%B5%D0%B4%D0%BE%D0%BC%D0%BB%D0%B5%D0%BD%D0%B8%D0%B9-%D0%B2-Telegram',
  cash_box:
    'https://support.smartshell.gg/hc/ru/articles/11055725620621-%D0%98%D0%BD%D1%82%D0%B5%D0%B3%D1%80%D0%B0%D1%86%D0%B8%D1%8F-%D0%BA%D0%B0%D1%81%D1%81%D1%8B-%D0%B2-SmartShell',
  sbp_tinkoff:
    'https://support.smartshell.gg/hc/ru/articles/29533517437197-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BF%D0%BB%D0%B0%D1%82%D1%8B-%D0%B8%D0%B7-%D1%88%D0%B5%D0%BB%D0%BB%D0%B0-%D0%B8-%D0%BC%D0%BE%D0%B1%D0%B8%D0%BB%D1%8C%D0%BD%D0%BE%D0%B3%D0%BE-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D1%8F-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-%D0%A1%D0%91%D0%9F',
  cloudPayments:
    'https://support.smartshell.gg/hc/ru/articles/21316643204365-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-CloudPayments',
  kaspi_POS: 'https://support.smartshell.gg',
  kaspi_online:
    'https://support.smartshell.gg/hc/ru/articles/34028386094861-%D0%9F%D0%BE%D0%B4%D0%BA%D0%BB%D1%8E%D1%87%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%D0%B6%D0%B5%D0%B9-%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%BE%D0%B2-%D1%87%D0%B5%D1%80%D0%B5%D0%B7-Kaspi-QR\n',
  stripe: 'https://support.smartshell.gg',
};

export const cashBoxDescription =
  'Оплата в клубе будет проводиться через выбранную кассу, с учётом настроенных  параметров и налогов. Поддерживаются несколько систем налогообложения.';

export const SBPDescription: FC = () => (
  <span>
    Клиенты смогут самостоятельно пополнять свой депозит через шелл, клиентский
    портал или мобильное приложение. Договор о приеме денежных средств{' '}
    <a
      className={s.sbp_link}
      target="_blank"
      href="https://storage.yandexcloud.net/smartshell-static/legal/oferta-dopuslugi12092024.pdf"
      rel="noreferrer"
    >
      здесь
    </a>
    .
  </span>
);
